import { SiteShell } from "@/components/site/SiteShell";
import { PageHero } from "@/components/site/PageHero";
import { SEO, breadcrumbSchema } from "@/components/site/SEO";
import { TEAM } from "@/lib/siteData";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ROUTE_SEO } from "@/lib/routeSeo";
import { ArrowRight } from "lucide-react";

export default function Crew() {
  return (
    <SiteShell>
      <SEO title={ROUTE_SEO["/crew"].title} description={ROUTE_SEO["/crew"].meta} path="/crew" jsonLd={breadcrumbSchema([{name: "Home", path: "/"}, {name: "Crew"}])} />
      <PageHero kicker="People" title={ROUTE_SEO["/crew"].h1} subtitle="Senior creative and technical talent - each project led by a producer who runs it end-to-end." breadcrumb={[{name: "Home", path: "/"}, {name: "Crew"}]} />
      <section className="section-pad">
        <div className="container-site space-y-16">
          {TEAM.map((m, i) => (
            <div key={m.name} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
              <div className="lg:col-span-5">
                <div className="aspect-[4/5] overflow-hidden rounded-2xl border border-border bg-card">
                  <img src={m.image} alt={m.name} className="h-full w-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                </div>
              </div>
              <div className="lg:col-span-7">
                <div className="font-display text-[hsl(var(--primary))] text-[clamp(2.5rem,6vw,5rem)] leading-none">{String(i+1).padStart(2, "0")}</div>
                <h2 className="mt-3 font-display uppercase text-foreground text-3xl sm:text-4xl tracking-[0.02em]">{m.name}</h2>
                <p className="mt-2 text-xs uppercase tracking-[0.22em] text-[hsl(var(--primary))]">{m.role}</p>
                <p className="mt-6 text-base text-muted-foreground leading-relaxed max-w-xl">{m.bio}</p>
              </div>
            </div>
          ))}
          <div className="text-center pt-4">
            <p className="text-sm text-muted-foreground mb-5">Want to join the crew? We’re always open to talented filmmakers.</p>
            <Button asChild className="h-12 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:brightness-110 px-6"><Link to="/careers">Careers & freelance <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
